import React from 'react';
import GameMap from './logic/GameMap';
import { mapConfigs } from './MapConfig/mapConfigs';
import SafariZoneTimer from '../../components/SafariZoneTimer';
import withSafariZoneProtection from '../../components/SafariZoneProtection';

const SafariZoneSouth = () => {
  return (
    <>
      <GameMap config={mapConfigs.safariZoneSouth} />
      <SafariZoneTimer />
    </>
  );
};

export default withSafariZoneProtection(SafariZoneSouth);
